import React, { useEffect, useState } from "react"
import { RootState, useTypedSelector } from "../app/store"
import { usePostMeasureOverviewMutation } from "../app/services/meseeknaApi"
import "./super-power.css"
import HeaderSection from "../components/header-section"
import Sidebar from "../features/sidebar/components/sidebar"
import { useGetMicroLearningByUserIdQuery } from "../app/services/meseeknaApi"
import { useParams } from "react-router-dom"

type SuperPower = {
  iconUrl: string
  measureName: string
  description: string
  microlearningProgress: string
}

type MicroLearningGoal = {
  iconUrl: string
  measureName: string
  description: string
}

const SuperPowerComponent: React.FC = () => {
  const { runId } = useParams()
  const authStore = useTypedSelector((state: RootState) => {
    return state.authSlice
  })
  const { data: microLearningsData } = useGetMicroLearningByUserIdQuery({
    userId: authStore.user.id,
    assignedTestId: Number(runId),
  })
  const [showSpinner, setShowSpinner] = useState(true)
  const [
    {
      superPower,
      microLearningGoal,
      leastScore,
      highestScore,
      microlearningProgress,
    },
    setState,
  ] = useState({
    superPower: null as SuperPower | null,
    microLearningGoal: null as MicroLearningGoal | null,
    microlearningProgress: "",
    leastScore: { iconUrl: "", measureName: "", description: "" },
    highestScore: { iconUrl: "", measureName: "", description: "" },
  })
  const [measureData] = usePostMeasureOverviewMutation()

  useEffect(() => {
    const fetchData = async (attempt = 1) => {
      const res = await measureData({
        body: {
          userId: authStore.user.id,
          measureId: microLearningsData?.data?.[0]?.measureId || 0,
        },
      })

      setShowSpinner(false)

      // Retry only if the response is missing expected data
      if ("data" in res && res.data?.data) {
        const { superPower, microLearningGoal } = res.data.data

        setState((prevState) => ({
          ...prevState,
          superPower: res.data.data.superPower,
          microLearningGoal: res.data.data.microLearningGoal,
          microlearningProgress:
            microLearningGoal.microlearningProgress.toLowerCase(),
          leastScore: {
            iconUrl: microLearningGoal.iconUrl,
            measureName: microLearningGoal.measureName,
            description: microLearningGoal.description,
          },
          highestScore: {
            iconUrl: superPower.iconUrl,
            measureName: superPower.measureName,
            description: superPower.description,
          },
        }))
      } else if (attempt < 3) {
        setTimeout(() => fetchData(attempt + 1), 500) // retry after delay
      } else {
        console.error("Final retry failed or data still missing.")
      }
    }

    localStorage.removeItem("user_runId")
    fetchData()
  }, [microLearningsData])

  useEffect(() => {}, [superPower, microLearningGoal])
  if (showSpinner) {
    return (
      <div className="spin">
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-info" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="relative bg-base-white w-full h-[100dvh] flex flex-row items-start justify-start font-text-md-regular">
      <Sidebar />
      <div className="w-full h-[100dvh] flex-1 flex flex-col">
        <HeaderSection hideBreadcrumbs hideHelpIcon hideProfileIcon />
        <div className="power custom-container-fluid">
          <div className="custom-container">
            <div className="custom-row">
              <div className="custom-col">
                <div className="super">
                  <div className="super-1">
                    <h1>Super Power</h1>
                  </div>
                </div>
              </div>
              <div className="custom-col">
                <div className="super">
                  <div className="super-1">
                    <h1>Course Overview Goal</h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="custom-row">
              <div className="custom-col">
                <div className="super-img">
                  <img src={highestScore?.iconUrl} alt="Super Power" />
                </div>
              </div>
              <div className="custom-col">
                <div className="super-img">
                  <div className="custom-row">
                    <div className="custom-col text-end">
                      <img
                        src={leastScore?.iconUrl}
                        alt="Micro Learning Goal"
                      />
                    </div>
                    <div className="custom-col text-start">
                      {microlearningProgress === "flower" && (
                        <img src="/v3/assets/Flower_7.png" alt="Flower" />
                      )}
                      {microlearningProgress === "mountain" && (
                        <img src="/v3/assets/Mountain_7.png" alt="Mountain" />
                      )}
                      {microlearningProgress === "puzzle" && (
                        <img
                          src="/v3/assets/Puzzle_7_COMPLETE.png"
                          alt="Puzzle"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="custom-row">
              <div className="custom-col">
                <div className="creative">
                  <div className="creative-1">
                    <h1>{highestScore?.measureName}</h1>
                  </div>
                  <div className="creative-2">
                    <p>{highestScore?.description}</p>
                  </div>
                </div>
              </div>
              <div className="custom-col">
                <div className="creative">
                  <div className="creative-1">
                    <h1>{leastScore?.measureName}</h1>
                  </div>
                  <div className="creative-2">
                    <p>{leastScore?.description}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SuperPowerComponent
